import type { SVGProps } from 'react';
const SvgSkipNext = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#skip_next_svg__a)">
      <path fill="currentColor" d="m6 18 8.5-6L6 6v12ZM16 6v12h2V6h-2Z" />
    </g>
    <defs>
      <clipPath id="skip_next_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSkipNext;
